'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var i18nInit = exports.i18nInit = undefined;

exports.i18nInit = i18nInit = function i18nInit(refs) {
    var t = this,
        appManager = refs.appManager,
        requestManager = refs.requestManager,
        i18nManager = refs.i18nManager,
        uiLocale = appManager.getUiLocale(),
        isUiLocaleDefault = appManager.isUiLocaleDefault(),
        defaultUiLocale = appManager.defaultUiLocale;

    return {
        baseUrl: 'i18n/i18n_app.properties',
        type: 'ajax',
        dataType: 'text',
        headers: {
            'Accept': 'text/plain; charset=utf-8'
        },
        success: function success(r) {
            var t = this;

            i18nManager.add(dhis2.util.parseJavaProperties(r));

            if (isUiLocaleDefault) {
                requestManager.ok(t);
            } else {
                $.ajax({
                    url: 'i18n/i18n_app_' + uiLocale + '.properties',
                    success: function success(r) {
                        i18nManager.add(dhis2.util.parseJavaProperties(r));
                    },
                    error: function error() {
                        console.log('(i18n) No translations found for system locale (' + uiLocale + ')');
                    },
                    complete: function complete() {
                        requestManager.ok(t);
                    }
                });
            }
        },
        error: function error() {
            $.ajax({
                url: 'i18n/i18n_app_' + uiLocale + '.properties',
                success: function success(r) {
                    i18nManager.add(dhis2.util.parseJavaProperties(r));
                },
                error: function error() {
                    alert('(i18n) No translations found for system locale (' + uiLocale + ') or default locale (' + defaultUiLocale + ')');
                },
                complete: function complete() {
                    requestManager.ok(this);
                }
            });
        }
    };
};
//# sourceMappingURL=i18nInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/i18nInit.js
 ** module id = 178
 ** module chunks = 0 1
 **/